import { Typography } from '@ori-ui/mui';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import useTestId from '@ori/testid-generator';
import { useMemo, type FC } from 'react';

import { LINK, LINKS_LIST } from './constants';
import { Root } from './styles';
import { type LinksProps } from './types';

export const Links: FC<LinksProps> = ({ items }) => {
  const { getTestId } = useTestId();
  const links = useMemo(
    () => items.filter((item) => item.linkType === StaticNavigationNavigationItemDtoLinkType.FooterColumnItem),
    [items],
  );

  return (
    <Root data-testid={getTestId(LINKS_LIST)}>
      {links.map((item) => (
        <Typography
          key={item.title}
          data-testid={getTestId(LINK)}
        >
          {item.url ? (
            <a
              aria-label={item.title}
              href={item.url}
              title={item.title}
            >
              {item.title}
            </a>
          ) : (
            item.title
          )}
        </Typography>
      ))}
    </Root>
  );
};
